import { createSelector } from 'reselect';

const downloadInvoices = state => state.billing.download;
const getInvoices = state => state.billing.invoices;
const getCurrentInvoice = state => state.billing.invoice;
const getPayment = state => state.billing.payment;

const filterLineItems = (invoice) => {
    const { currentInvoice, currentInvoiceFilters } = invoice;
    if (!currentInvoice) return [];
    const { invoiceItems } = currentInvoice;
    if (!invoiceItems) return [];
    if (!Object.keys(currentInvoiceFilters).length) return invoiceItems;
    let filteredItems = invoiceItems.slice();
    // eslint-disable-next-line guard-for-in
    for (const key in currentInvoiceFilters) {
        const filter = currentInvoiceFilters[key];
        const filterSet = new Set();
        filter.value.forEach((v) => {
            if (v.isChecked) filterSet.add(v.label);
        });
        if (filterSet.size) {
            filteredItems = filteredItems.filter(item => filterSet.has(item[key]));
        }
    }
    return filteredItems;
};

const BillingSelectors = {
    makeCurrentInvoiceSelector: createSelector([getCurrentInvoice], invoice => invoice.currentInvoice),
    makeCurrentInvoiceLineItems: createSelector([getCurrentInvoice], filterLineItems),
    makeCurrentInvoiceLoadingState: createSelector([getCurrentInvoice], invoice => invoice.currentInvoiceLoadingState),
    makeCurrentInvoiceErrorMessage: createSelector([getCurrentInvoice], invoice => invoice.currentInvoiceErrorMessage),
    makeCurrentInvoiceFilters: createSelector([getCurrentInvoice], invoice => invoice.currentInvoiceFilters),
    makeMultiFamilyPropertyMap: createSelector([getInvoices], invoices => invoices.multiFamilyPropertyMap),
    makeInvoicesDownloadState: createSelector([downloadInvoices], download => download.downloadState),
    makeInvoicesDownloadErrorMessage: createSelector([downloadInvoices], download => download.downloadErrorMessage),
    makePaymentSessionInfo: createSelector([getPayment], payment => payment.paymentSessionInfo),
    makePaymentSessionInfoLoadingState: createSelector([getPayment], payment => payment.paymentSessionInfoLoadingState),
};

export default BillingSelectors;
